<template>
  <el-dialog
    :title="dialogTitle"
    width="900px"
    :visible.sync="isShow"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    @closed="isShow=false"
    :key="currentTimer"
    :append-to-body="true"
  >
    <query-form :inline="true" size="mini" label-width="10px" style="padding:0;">
      <el-form-item label="" label-width="0px">
        <el-input v-model.trim="form.name" placeholder="请输入品牌名称"></el-input>
      </el-form-item>
      <el-button type="primary" slot="action"  @click="handleSearch">查询</el-button>
      <el-button type="default" slot="action"  @click="handleReset">重置</el-button>
    </query-form>
    <TableWithPagination
      size='mini'
      :tableData="targetLists"
      :columnList="columnList"
      row-key='id'
      ref="checkboxTable"
      :leftToolbar="tableButtons"
      :checkbox-config="checkboxConfig"
      :pagination.sync="pagination"
      @size-change="getTargetLists"
      @selection-change="handleSelectionChange"
      max-height="400px"
      @current-change="getTargetLists"
      :sortInfo.sync="sortInfo"
      @sort-change="getTargetLists">
    </TableWithPagination>
    <div slot="footer">
      <el-button size="mini" @click="isShow = false">取消</el-button>
      <el-button type="primary" size="mini" @click="handleConfirm">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { saveCategoryBrand, getCategoryBrandList } from '@/api/PlatformSales/Category.js';
import { getBrandLists } from '@/api/PlatformSales/Brand';
export default {
  name: '',
  mixins: [TablePaginationMixin],
  components: {
    TableWithPagination,
  },
  methods: {
    initPage () {
      this.form = this.form = this.$options.data().form;
      this.isShow = true;
      this.currentTimer = Date.now();
      this.targetLists = [];
      this.getAllCategoryBrandList();
      this.$nextTick(() => {
        this.checkboxConfig = JSON.parse(JSON.stringify(this.checkboxConfig));
      });
    },
    getAllCategoryBrandList () {
      getCategoryBrandList({
        categoryId: this.currentId,
      }).then(({body}) => {
        this.selectedLists = body || [];
        this.handleSearch();
      });
    },
    handleSelectionChange (selectedLists) {
      this.selectedLists = selectedLists || [];
    },
    handleReset () {
      this.form = this.$options.data().form;
      this.handleSearch();
    },
    handleSearch () {
      this.pagination.currentPage = 1;
      this.getTargetLists();
    },
    getTargetLists () {
      let currentParams = {
        ...this.form,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      };
      getBrandLists(currentParams).then(({body}) => {
        this.pagination.total = body.total;
        let currentLists = body.list || [];
        let tempLists = currentLists.map(item => {
          return {
            name: item.name || '',
            id: item.id,
          };
        });
        this.targetLists = tempLists;
        this.$nextTick(() => {
          this.$refs.checkboxTable.setCheckboxRow(this.selectedLists, true);
        });
      });
    },
    handleConfirm () {
      if (!this.selectedLists.length) {
        this.$message.warning(`请${this.dialogTitle}`);
        return;
      }
      const currentParams = {
        brandIds: this.selectedLists.map(i => i.id),
        categoryId: this.currentId,
      };
      if (this.currentId) {
        saveCategoryBrand(currentParams).then(() => {
          this.isShow = false;
          this.$emit('handleUpdatePage');
        });
      }
      this.isShow = false;
    },
  },
  computed: {
    // 按钮组
    tableButtons () {
      return [
        {
          type: 'custom',
          render: () => {
            return (
              <p style="padding: 0;display:flex;"><span>当前选中内容：</span><span style="color:#f33;flex: 1;">{this.selectedLists.map(i => i.name).join('，')}</span></p>
            );
          },
        },
      ];
    },
    columnList () {
      let currentLists = [
        {
          tooltip: true,
          label: '全选',
          type: 'checkbox',
          minWidth: 100,
          fixed: 'left',
        },
        {
          tooltip: true,
          label: '品牌名称',
          minWidth: '180px',
          prop: 'name',
        },
      ];
      return currentLists;
    },
  },
  data () {
    return {
      name: '',
      isRadio: false,
      dialogTitle: '',
      currentTimer: '',
      currentId: '',
      selectedLists: [],
      form: {
        name: '',
      },
      checkboxConfig: {
        reserve: true,
        highlight: true,
      },
      targetLists: [],
      isShow: false,
    };
  },
};
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */

</style>
